import React, { useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Spinner } from 'reactstrap'
import LoginContext from '../../context/Login/LoginContext';
import TenantContext from '../../context/Tenant/TenantContext';
import { ErrorScreen } from '@exactian/exactian-components';
import { getUserDataByKey } from '../../helpers/helpers';
import { t } from 'i18next';

export const LoginExactian = () => {

    const { token } = useParams();

    const { getTenant, tenant } = useContext(TenantContext)

    const { loginSessionExactian } = useContext(LoginContext)

    const language = getUserDataByKey('language') || 'es';

    useEffect(() => {
        getTenant();
        loginSessionExactian(token)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (tenant.error) {
        <ErrorScreen
            language={language}
            message={t('common.error_tenant')}
        />
    }

    if (!tenant.error) {
        return (
            <div className='position-absolute top-50 start-50'>
                <Spinner size={'xl'} />
            </div>
        )
    }

}
